import Vue from 'vue';

import httpActivity from './http-activity';
import httpDictionary from './http-dictionary';
import httpMain from './http-main';

Vue.prototype.$httpActivity = httpActivity;
Vue.prototype.$httpDictionary = httpDictionary;
Vue.prototype.$httpMain = httpMain;
